import type { MaterialRequirementsFormValues } from "../types"

import { LabelType } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const LABEL_TYPE_OPTIONS: Option<LabelType>[] = [
  { value: LabelType.PoNumber, label: "PO Number" },
  { value: LabelType.SalesOrderNumber, label: "Sales Order Number" },
  { value: LabelType.ShipDate, label: "Ship Date" },
  { value: LabelType.ManufacturingDate, label: "Manufacturing Date" },
  { value: LabelType.ExpirationDate, label: "Expiration Date" },
  { value: LabelType.ProductId, label: "Product ID" },
  { value: LabelType.CustomerCode, label: "Customer Code" },
  { value: LabelType.LotNumber, label: "Lot Number" },
  { value: LabelType.NumberOfPackages, label: "Number of Packages" },
  { value: LabelType.TotalUom, label: "Total UOM" },
  { value: LabelType.AkrochemProductName, label: "Akrochem Product Name" },
  { value: LabelType.CustomerProductName, label: "Customer Product Name" },
]

export const DEFAULT_MATERIAL_REQUIREMENTS: MaterialRequirementsFormValues = {
  allowsRecertifiedMaterial: true,
  prefersNewestMaterial: false,
  shelfLifeRequired: false,
  shelfLifeRequirement: undefined,
  changeApprovalRequired: false,
  prefersFewestLots: false,
  labelConfiguration: null,
}
